import {
  ContentCopy as ContentCopyIcon,
  DeleteOutline as DeleteOutlineIcon,
} from '@mui/icons-material';
import { Menu } from 'src/components/menu';
import { lang, useUserRole } from 'src/utils';

import { LocationGroupMenuProps } from './LocationGroupMenu.interface';

export const LocationGroupMenu = (props: LocationGroupMenuProps) => {
  const { isViewOnly } = useUserRole();

  const hasLocations = props.row.locations_count > 0;

  const onDuplicateClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onDuplicateClick();
    props.onClose();
  };

  const onDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onDeleteClick();
    props.onClose();
  };

  const items = [
    {
      label: lang.duplicate,
      onClick: onDuplicateClick,
      leftIcon: <ContentCopyIcon />,
      disabled: isViewOnly,
    },
    {
      label: lang.delete,
      onClick: onDeleteClick,
      leftIcon: <DeleteOutlineIcon />,
      disabled: isViewOnly || hasLocations,
      tooltip: hasLocations ? lang.deleteGroupTooltip : undefined,
      tooltipPlacement: 'left' as const,
      tooltipWidth: 290,
    },
  ];

  return (
    <Menu anchorEl={props.anchorEl} items={items} onClose={props.onClose} />
  );
};
